export default "__VITE_ASSET__BA8M$SuN__"